<template>
    <div class="deed-owner-holder-edit-wrapper">
        <form autocomplete="off" method="post" :data-vv-scope="vScope" @keyup.enter="() => {return false;}" @submit.prevent="() => {return false;}">
            <div class="row">
                <div class="col-12 col-sm-6 col-xl-3">
                    <MaterialSelect
                        :disabled="readonlyForm"
                        class="city-form-group city-bg"
                        id="input-holder_start_type"
                        name="holder_start_type"
                        label="name"
                        v-model.trim="form.deed_owner_holder_start_type_id"
                        :options="start_types"
                        v-validate="rulesField('deed_owner_holder_start_type_id')"
                        :data-vv-scope="vScope"
                        :inputClasses="[{'is-invalid': fnHasError('holder_start_type', vScope)}]"
                        :error="fnFirstError('holder_start_type', vScope)">
                        {{ $t(`${modelTranslateID}.start_type`) }}
                    </MaterialSelect>
                </div>
                <div class="col-12 col-sm-6 col-xl-3">
                    <div class="form-group">
                        <MaterialDatePicker
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-holder_start_at"
                            name="holder_start_at"
                            v-model.trim="form.deed_owner_holder_start_at"
                            :dateFormat="labelDateFormat"
                            :databaseDateFormat="dateFormat"
                            v-validate="rulesField('deed_owner_holder_start_at')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('holder_start_at', vScope) }]"
                            :error="fnFirstError('holder_start_at', vScope)">
                            {{ $t(`${modelTranslateID}.start_at`) }}
                        </MaterialDatePicker>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-xl-3">
                    <MaterialSelect
                        :disabled="readonlyForm"
                        class="city-form-group city-bg"
                        id="input-holder_end_type"
                        name="holder_end_type"
                        label="name"
                        v-model.trim="form.deed_owner_holder_end_type_id"
                        :options="end_types"
                        v-validate="rulesField('deed_owner_holder_end_type_id')"
                        :data-vv-scope="vScope"
                        :inputClasses="[{'is-invalid': fnHasError('holder_end_type', vScope)}]"
                        :error="fnFirstError('holder_end_type', vScope)">
                        {{ $t(`${modelTranslateID}.end_type`) }}
                    </MaterialSelect>
                </div>
                <div class="col-12 col-sm-6 col-xl-3">
                    <div class="form-group">
                        <MaterialDatePicker
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-holder_end_at"
                            name="holder_end_at"
                            v-model.trim="form.deed_owner_holder_end_at"
                            :dateFormat="labelDateFormat"
                            :databaseDateFormat="dateFormat"
                            v-validate="rulesField('deed_owner_holder_end_at')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('holder_end_at', vScope) }]"
                            :error="fnFirstError('holder_end_at', vScope)">
                            {{ $t(`${modelTranslateID}.end_at`) }}
                        </MaterialDatePicker>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 entity">
                    <h6 class="header">{{ $t(`${translateID}.form.entity`)}}</h6>
                    <hr class="mt-1 mb-3" />
                    <div class="row">
                        <div class="col-12">
                            <EntityDetails
                                v-model="form.entity"
                                :additional="additional"
                                :panelCfg="panelCfg"
                                :vScope="vScope"
                                :readonlyForm="readonlyForm"
                                :action="onlySelectAndViewAction"
                                baseTranslateID="entities"
                                :genders="genders"
                                :religions="religions"
                                :causes_death="causes_death"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import FormMixin from "./mixins/FormMixin";
import { ENTITY_FORM_ACTIONS } from "../../../shared/config/constants";

export default {
    mixins: [
        FormMixin,
    ],
    components: {
        MaterialDatePicker: () => import(/* webpackChunkName: "datepicker" */ '@/components/form/MaterialDatePicker'),
        EntityDetails: () => import(/* webpackChunkName: "cemeteries-entity-details" */ './elements/EntityDetails'),
    },
    props: {
        start_types: {
            type: Array,
            default: () => {return [];},
        },
        end_types: {
            type: Array,
            default: () => {return [];},
        },
        genders: {
            type: Array,
            default: () => {return [];},
        },
        religions: {
            type: Array,
            default: () => {return [];},
        },
        causes_death: {
            type: Array,
            default: () => {return [];},
        },
    },
    data() {
        let idPanel = 'deed_owner_holder';
        return {
            idPanel: idPanel,
        }
    },
    computed: {
        onlySelectAndViewAction() {
            return ENTITY_FORM_ACTIONS.ONLY_SELECT_AND_VIEW;
        },
    },
    methods: {

    },
    watch: {
        form: {
            deep: true,
            handler: function(value, oldValue){
                if(value && value?.entity) {
                    value.entity_id = value.entity.id;
                }

                this.$emit('input', value);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
</style>